import { useSelector } from 'react-redux';
import { usePaidReportExperiment } from 'shared/hooks/usePaidReportExperiment';

import { EDealType, EOfferType } from '../../../repositories/offer-card/entities/offer/OfferSchema';
import {
  selectDealType,
  selectIsAgent,
  selectIsOfferOwnedByUser,
  selectOfferCategory,
  selectOfferType,
} from '../../../selectors';

export const STATIC_DATA = [
  {
    title: 'Арендная ставка по оценке Циана',
    description: 'Поможет арендатору поторговаться, а собственнику — сдать квартиру выгоднее и быстрее',
    tooltipText:
      'Оценку рассчитали, используя объявления похожих квартир. Учли характеристики квартир, наличие мебели и техники, а также условия аренды.',
  },
  {
    title: 'Оценка этого участка от Циана',
    description: 'Поможет покупателю поторговаться, а продавцу — продать участок выгоднее и быстрее',
    tooltipText:
      'Оценку рассчитали, используя объявления похожих участков. Учли участки, снятые с продажи и цены сделок.',
  },
  {
    title: 'Оценка этого дома от Циана',
    description: 'Поможет покупателю поторговаться, а продавцу — продать дом выгоднее и быстрее',
    tooltipText: 'Оценку рассчитали, используя объявления похожих домов. Учли дома, снятые с продажи и цены сделок.',
  },
  {
    title: 'Оценка этой квартиры от Циана',
    description: 'Поможет покупателю поторговаться, а продавцу — продать квартиру выгоднее и быстрее',
    tooltipText:
      'Оценку рассчитали, используя объявления похожих квартир. Учли квартиры, снятые с продажи и цены сделок.',
  },
];

const PAID_REPORT_STATIC_DATA = {
  title: 'Оценка этой квартиры от Циана',
  description: 'Поможет покупателю поторговаться и не переплатить за квартиру',
  tooltipText:
    'Оценку рассчитали, используя объявления похожих квартир. Учли квартиры, снятые с продажи и цены сделок.',
};

/** TODO: Будет перенесено на бэк в задаче https://jira.cian.tech/browse/VAL-2997 */
export const useStaticData = () => {
  const offerCategory = useSelector(selectOfferCategory);
  const offerType = useSelector(selectOfferType);
  const dealType = useSelector(selectDealType);
  const isOfferByUser = useSelector(selectIsOfferOwnedByUser);
  const isAgent = useSelector(selectIsAgent);
  const isPaidReportExperiment = usePaidReportExperiment();
  const isFlatSale = dealType === EDealType.Sale && offerType === EOfferType.Flat;

  if (isPaidReportExperiment && isFlatSale && !isOfferByUser && !isAgent) {
    return PAID_REPORT_STATIC_DATA;
  }

  if (dealType === EDealType.Rent) {
    return STATIC_DATA[0];
  }

  if (offerType === EOfferType.Suburban) {
    return offerCategory === 'landSale' ? STATIC_DATA[1] : STATIC_DATA[2];
  }

  return STATIC_DATA[3];
};
